import { ApiError } from './api.js';

const MESSAGES: Record<string, string> = {
  status_changed: 'Közben módosult — frissítsd',
  use_editor: 'Ügyfélnél lévő vagy publikált poszt — a szerkesztőben válts állapotot',
  status_not_settable: 'Erre az állapotra nem lehet kézzel váltani',
  not_found: 'A poszt nem található',
};

const NOT_AVAILABLE = 'A gyors váltás még nem érhető el — próbáld a szerkesztőben';
const UNDO_STALE = 'Nem állt vissza: azóta módosult';
const FALLBACK = 'Az állapotváltás nem sikerült';

/**
 * Hungarian user message for a failed quick status change. A 404 without a
 * known code means the API predates the endpoint (rolling update).
 * `undo` selects the wording for a stale undo.
 */
export function quickStatusErrorMessage(err: unknown, opts: { undo?: boolean } = {}): string {
  const code = err instanceof ApiError ? err.code : null;
  if (opts.undo && code === 'status_changed') return UNDO_STALE;
  return messageForCode(code, err instanceof ApiError ? err.status : null);
}

/** Same mapping for a `failed[]` entry of the bulk response (a code only). */
export function quickStatusCodeMessage(code: string): string {
  return messageForCode(code, null);
}

function messageForCode(code: string | null, status: number | null): string {
  const known = code ? MESSAGES[code] : undefined;
  if (known) return known;
  if (status === 404) return NOT_AVAILABLE;
  return FALLBACK;
}
